export const subscriptionConfiguration = [

    {
        value: 'BTC',
        label: 'BTC',
        channel: "BTCOnChain",
        children: [
            {
                value: '链上数据',
                label: 'menu.onchain',
                id: "ls",
                children: [                 
                    {
                        value: '网络',
                        label: 'menu.Network',
                        id: "ls-1",
                        children: [
                            {

                                value: '交易量',
                                label: 'menu.TransactionVolume',
                                alarmType: [`subscribe.numericalValue`,],
                                alarmInterval: [`realTime`,],
                                channel: "BTCOnChain",
                                id: "ls-1-1",


                            },
                            {

                                value: '交易费',
                                label: 'menu.TransactionFee',
                                alarmType: [`subscribe.numericalValue`,],
                                alarmInterval: [`realTime`,],
                                channel: "BTCOnChain",
                                id: "ls-1-2",


                            },
                            {

                                value: '交易量(找零消除)',
                                label: 'menu.adjusted',
                                alarmType: [`subscribe.numericalValue`,],
                                alarmInterval: [`realTime`,],
                                channel: "BTCOnChain",
                                id: "ls-1-3",


                            },
                        ],
                    },
                    {
                        value: '地址',
                        label: 'menu.address',
                        id: "ls-2",
                        children: [
                            {

                                value: '地址统计',
                                label: 'menu.onchain2',
                                children: [{
                                    value: '活跃地址数',
                                    label: 'menu.activeAddresses',
                                    alarmType: [`subscribe.numericalValue`,],//数值
                                    alarmInterval: [`realTime`,],
                                    channel: "BTCOnChain",
                                    id: "ls-2-1",
                                },
                                {
                                    value: '发送地址数',
                                    label: 'menu.SendAddresses',
                                    alarmType: [`subscribe.numericalValue`,],
                                    alarmInterval: [`realTime`,],
                                    channel: "BTCOnChain",
                                    id: "ls-2-2",

                                },
                                {
                                    value: '接收地址数',
                                    label: 'menu.ReceiveAddresses',
                                    alarmType: [`subscribe.numericalValue`,],
                                    alarmInterval: [`realTime`,],
                                    channel: "BTCOnChain",
                                    id: "ls-2-3",
                                },

                                ]

                            },
                            {

                                value: '巨鲸地址列表',
                                label: 'menu2.onchain2',
                                alarmType: [`subscribe.address`,],//地址
                                alarmInterval: [`subscribe.day`,],//1天
                                channel: "BTCOnChain",
                                id: "ls-2-4",
                             

                            
                            },
                        ],
                    },                   
                    {
                        value: '币龄',
                        label: 'menu2.Lifetime',
                        id: "ls-3",
                        children: [
                            {

                                value: '已花费输出平均寿命',
                                label: 'menu2.asol',
                                alarmType: [`subscribe.ratio`,],//比值
                                alarmInterval: [`realTime`,],
                                channel: "BTCOnChain",
                                id: "ls-3-1",


                            },
                            {

                                value: '币天销毁量',
                                label: 'menu.technology37',
                                alarmType: [`subscribe.numericalValue`,],
                                alarmInterval: [`realTime`,],
                                channel: "BTCOnChain",
                                id: "ls-3-2",


                            },
                          
                        ],
                    },                
                ],
            },
            
        ]
    },


]